import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2 } from 'react-feather';

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../../common'

export const ManagementLogTable = ({ useFetchInit, readOnlyMode }) => {

    const {
        FetchData,
        Actions
    } = useFetchInit
    
    const { fetchAllLogs } = FetchData
    const { dataLogs, loadingFetchLogs } = fetchAllLogs
    
    const {
        handleClickDeleteLog
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } =
                    params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "date_log", headerName: "FECHA", minWidth: 200, filter: true },
        { field: "nombre_usuario", headerName: "USUARIO", minWidth: 200, filter: true },
        { field: "descripcion", headerName: "DESCRIPCION", minWidth: 1000, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idlawyerlogs, estado } = params.data
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickDeleteLog(idlawyerlogs)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchLogs)&&(<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataLogs}
                columnConfig={columnConfig}
            />
        </div>
    )
}
